import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

/* eslint-env browser */
import React, { useContext } from 'react';
import { TabsContext, TabsItemContext } from './context';
import { getTabButtonID, getTabPanelID } from './helpers';
import TabButton from './components/TabButton';

var Tab = function Tab(_ref) {
  var name = _ref.name,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "children"]);

  var _useContext = useContext(TabsContext),
      selected = _useContext.selected,
      select = _useContext.select,
      focus = _useContext.focus,
      focusNext = _useContext.focusNext,
      focusPrevious = _useContext.focusPrevious,
      focusFirst = _useContext.focusFirst,
      focusLast = _useContext.focusLast,
      refs = _useContext.refs,
      refsInner = _useContext.refsInner;

  var _useContext2 = useContext(TabsItemContext),
      first = _useContext2.first,
      last = _useContext2.last,
      fullWidth = _useContext2.fullWidth;

  return /*#__PURE__*/React.createElement(TabButton, _extends({
    name: name,
    role: "tab",
    "aria-selected": selected === name ? 'true' : 'false',
    "aria-controls": getTabPanelID(name),
    id: getTabButtonID(name),
    first: first,
    last: last,
    fullWidth: fullWidth,
    selected: selected,
    select: select,
    focus: focus,
    focusNext: focusNext,
    focusPrevious: focusPrevious,
    focusFirst: focusFirst,
    focusLast: focusLast,
    refs: refs,
    refsInner: refsInner
  }, selected === name ? {} : {
    tabIndex: -1
  }, props), children);
};

export default Tab;